import { Component } from '@theme/component';
import { fetchConfig } from '@theme/utilities';
import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Upsell-rækken i kurv-nudgen (snippets/locktown-cart-nudge.liquid).
 * Lægger varianten i kurven og sender samme event som product-form.js, så
 * cart-items-component morpher draweren med de nye sektioner, og cart-icon
 * opdaterer tallet. Rækken forsvinder, fordi Liquid ikke renderer den, når
 * produktet ligger i kurven.
 *
 * @typedef {object} Refs
 * @property {HTMLButtonElement} button
 *
 * @extends {Component<Refs>}
 */
class LocktownCartUpsellComponent extends Component {
  requiredRefs = ['button'];

  async add() {
    const { button } = this.refs;
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');

    const variantId = this.dataset.variantId ?? '';
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : undefined))
      .filter(Boolean);

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(
        Theme.routes.cart_add_url,
        fetchConfig('json', {
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
        })
      ).then((res) => res.json());

      if (response.status) throw new Error(response.description || response.message || 'Add to cart failed');

      const cart = await fetch(`${Theme.routes.cart_url}.js`).then((res) => res.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'locktown-cart-upsell-component',
          itemCount: 1,
          sections: response.sections,
          didError: false,
        },
      });
    } catch (error) {
      console.warn(error);
      deferred.reject(error);
      button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('locktown-cart-upsell-component')) {
  customElements.define('locktown-cart-upsell-component', LocktownCartUpsellComponent);
}
